import React from 'react';
import styles from './styles.module.css';

import SearchIcon from '../../icons/Search';

export default ({ value, onChange, applySearchTerm }) => (
  <form
    className={styles.container}
    onSubmit={event => {
      event.preventDefault();
      applySearchTerm();
    }}
  >
    <label className="a11y-hide" htmlFor="search-term">
      Search term
    </label>
    <input
      type="text"
      id="search-term"
      name="search-term"
      placeholder="Enter a search term"
      value={value}
      onChange={onChange}
    />
    <button onClick={applySearchTerm}>
      <SearchIcon size={16} />
    </button>
  </form>
);



// WEBPACK FOOTER //
// ./src/components/search-box/index.js